import { baseApiUrl } from '@fund-base/constants/general/general.constants';

export const smartAgentBaseApiUrl = `${baseApiUrl}/smart-agent`;
export const smartAgentMailBaseApiUrl = `${baseApiUrl}/smart-agent/mail`;
